import store from "../store";
import api from "../api";

/**
 * Check that current user is allowed to access the routes.
 * @param {{meta: {groups?: String[]}}[]} matched Array of route objects.
 * @returns {Boolean}
 */
export const isDashboardRouteAllowed = (matched) =>
  matched.every((record) =>
    record.meta.groups ? store.getters.hasAnyGroup(record.meta.groups) : true,
  );

export function beforeRouteEnter(to, from, next) {
  if (api.isTokenSet()) {
    store.dispatch("fetchUserData").then(() => next());
  } else {
    next();
  }
}
